import { Button, notification } from 'antd';
import { Fragment, PureComponent, ReactNode } from 'react';
import { Translate } from '../../api/pushVisit';
import { captureError } from '../../pages/captureError';
import { isForRxMonetisation } from '../../pages/utils';
import {
    getItemFromMisc,
    MISC_KEYS,
    getAllUnpushedPrescriptions,
    getPrintConfig,
} from '../../store/idbHandler';
import { Prescription } from '../../store/types/prescription';
import { track } from '../../tracking';
import { triggerPushVisit } from '../prescriptionPad/rightPanel/finishScreen/FinishedPanel';
import { RunningDiagnosisStatusType, RunningDiagnosisStrip } from './RunningDiagnosisStrip';
import { getMyDbId } from '../../api/mactiveid';

type P = {
    onSuccess: (obj: { [k: string]: string }) => void;
    onFailure: (obj: { [k: string]: string }) => void;
};

type S = {
    status: RunningDiagnosisStatusType;
    rxDrafts?: Prescription[];
    isPushing?: boolean;
};

class RxPushFailedCheck extends PureComponent<P, S> {
    state: S = {
        status: 'running',
    };

    onMount = async (): Promise<void> => {
        let status: RunningDiagnosisStatusType = 'running';
        let prescriptions: Prescription[] = [];
        try {
            prescriptions = (await getAllUnpushedPrescriptions()) || [];

            status = prescriptions.length ? 'warning' : 'success';
        } catch (e) {
            console.log('error', e);
            status = 'failed';
        }

        this.setState({
            status: status,
            rxDrafts: prescriptions,
            isPushing: false,
        });

        const { onSuccess } = this.props;

        onSuccess({
            status,
            name: 'rxPushFailedCheck',
            count: prescriptions.length.toString(),
        });
    };

    componentDidMount = async (): Promise<void> => {
        this.onMount();
    };

    pushRx = async (): Promise<void> => {
        try {
            const { rxDrafts } = this.state;
            if (!rxDrafts || !rxDrafts.length) {
                return;
            }

            this.setState({ isPushing: true });

            track('pushRx', { ids: rxDrafts.map((rx) => rx.id).toString() });

            const printConfig = await getPrintConfig(getMyDbId() || '');

            const translate = await getItemFromMisc<Translate>(
                getMyDbId() || '',
                MISC_KEYS.translate,
            );

            for (let index = 0; index < rxDrafts.length; index++) {
                const element = rxDrafts[index];
                await new Promise(
                    async (r, reject) =>
                        await triggerPushVisit(
                            element,
                            printConfig,
                            translate,
                            undefined,
                            undefined,
                            undefined,
                            (error) => {
                                if (error) {
                                    reject(error);
                                    return;
                                }

                                r(null);
                            },
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            isForRxMonetisation(),
                        ),
                );
            }

            notification.success({
                message: `Successfully pushed ${rxDrafts.length} prescription(s)`,
                duration: 5,
            });
        } catch (e) {
            captureError(e as Error);
            notification.error({
                message: 'Failed to push prescription',
                duration: 5,
            });

            track('ERROR', { on: 'rxDraftPush', what: (e as Error).message });
        }

        this.onMount();
    };

    render(): ReactNode {
        const { status, rxDrafts, isPushing } = this.state;
        return (
            <Fragment>
                <RunningDiagnosisStrip name="Unsynced Prescriptions" status={status} />
                {rxDrafts?.length ? (
                    <div className="px-16">
                        Found {rxDrafts?.length} draft(s){' '}
                        <Button className="mx-4" onClick={this.pushRx} loading={isPushing}>
                            Sync now
                        </Button>
                    </div>
                ) : null}
                {this.props.children}
            </Fragment>
        );
    }
}

export default RxPushFailedCheck;
